// extracted by mini-css-extract-plugin
export default {"task-list":"yLMeTSKvP0Gz3nIbProi"};